export const DEPENDENCY_SEARCH_PLACEHOLDER = 'Choose predecessor';
